"use client";

import { byPrefixAndName } from "@awesome.me/kit-12cf79935c/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRef, useState } from "react";

export default function SearchBar({
  placeholder = "Ara...",
  onSearch,
  containerClass = "mx-auto w-full md:max-w-[240px]",
  showClearOnType = false,
  hideIconWhenClear = true,
  onBlur,
}) {
  const [searchTerm, setSearchTerm] = useState("");
  const inputRef = useRef(null);

  const handleSearch = (e) => {
    e.preventDefault();
    onSearch(searchTerm);
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    // Real-time search için onSearch'ü çağır
    onSearch(value);
  };

  const handleClear = () => {
    setSearchTerm("");
    onSearch("");
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  const showClearButton = showClearOnType && searchTerm.length > 0;

  return (
    <div className={containerClass}>
      <form onSubmit={handleSearch} className="relative">
        <div className="relative">
          <input
            type="text"
            placeholder={placeholder}
            value={searchTerm}
            onChange={handleInputChange}
            ref={inputRef}
            onBlur={onBlur}
            className="border-border-card text-foreground-muted bg-background-global focus:border-border-card w-full rounded-[99px] border py-3 pr-4 pl-4 text-base font-normal transition-all duration-200 outline-none focus:ring-0 focus:ring-offset-0"
          />
          {showClearButton ? (
            <button
              type="button"
              onClick={handleClear}
              aria-label="Clear search"
              className="text-foreground absolute top-1/2 -translate-y-1/2 transform rounded-full p-1 hover:opacity-80 ltr:right-2 rtl:left-2"
            >
              <FontAwesomeIcon
                icon={byPrefixAndName.fas["xmark"]}
                className="h-5 w-5"
              />
            </button>
          ) : (
            (!hideIconWhenClear || !showClearButton) && (
              <FontAwesomeIcon
                icon={byPrefixAndName.fas["magnifying-glass"]}
                className="text-foreground absolute top-1/2 h-5 w-5 -translate-y-1/2 transform ltr:right-3 rtl:left-3"
              />
            )
          )}
        </div>
      </form>
    </div>
  );
}
